module.exports = __webpack_public_path__ + "img/course-cover02.a5f9cf8f.jpg";